module.exports = __webpack_public_path__ + "img/book3.38e4b4c.png";